// this defines any permission values for any restricted areas in the app

export const PERMISSIONS = {
  DASHBOARD: {
    SRS_STATISTICS_CARD: "APP_PERMISSIONS__DASHBOARD__SRS_STATISTICS_CARD",
    EAS_SEARCH_CARD: "APP_PERMISSIONS__DASHBOARD__EAS_STATISTICS_CARD",
    VIEW_SRS_APPLICATIONS_LINK: "APP_PERMISSIONS__DASHBOARD__VIEW_SRS_APPLICATIONS_LINK",
    INFO_BOX: {
      EAS: "APP_PERMISSIONS__DASHBOARD__INFO_BOX__EAS",
      HT_FILL_EIS_FORM: "APP_PERMISSIONS__DASHBOARD__INFO_BOX__HT_FILL_EIS_FORM"
    }
  },
  RATINGS: {
    UAC_RATING_FORM: "APP_PERMISSIONS__RATINGS_UAC_RATING_FORM",
    UTAS_RATING_FORM: "APP_PERMISSIONS__RATINGS_UTAS_RATING_FORM"
  },
  SRS_APPLICATION: {
    FLAG_BUTTON: "APP_PERMISSIONS__SRS_APPLICATION_FLAG_BUTTON",
    RATE_STUDENTS: "APP_PERMISSIONS___RATE_STUDENTS"
  }
};
